import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse } from '@/utils'
import { APIErrorResponse } from '@/types'

export const useDeleteQuotationResearch = (
  quotationId: number,
  researchId: number
): UseMutationResult<unknown, APIErrorResponse, void> => {
  const client = useApiClient()

  return useMutation(() =>
    client
      .delete(`/quotations/${quotationId}/researches/${researchId}/`)
      .catch(unwrapErrorResponse)
  )
}
